import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.574 3.336a5.33 5.33 0 0 0-6.363.914L3.348 6.005h2.32a.667.667 0 0 1 0 1.333h-3.99a.67.67 0 0 1-.451-.166.67.67 0 0 1-.226-.5v-4a.667.667 0 0 1 1.333 0v2.456L4.29 3.286a6.667 6.667 0 1 1-1.578 6.941.667.667 0 0 1 1.258-.444 5.334 5.334 0 1 0 7.603-6.447"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })